<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh-bot" id="curse"> </p>
<p class="ct"><span class="epub-bi">The Curse</span></p>
<p class="co">In 1119, nine knights rode with Hugues de Payens to the Holy Land, becoming the Knights Templar. All were bound by marriage or by blood. Eight were recorded over time. The ninth vanished into history.</p>
<p class="tx">Beneath the legendary Temple Mount, the knights uncovered holy relics, including the Copper Scroll—a document written by Azazel’s unholy hand. For their forbidden digging, the archangels exacted a sacrifice. The knights would spend eternity battling the demons of Azazel’s creation, but with each vile death they claimed, a portion of darkness would enter their soul. In time, they would transform into knights of Azazel, warriors veined with evil, destined to fight against the Almighty.</p>
<p class="tx">Yet an ancient prophecy remained to give them hope. When darkness raped the land, the seraphs would return. Female descendants of the Nephilim would carry the light to heal their dying souls.</p>
<p class="tx">Centuries have passed. Azazel’s might grows to intolerable limits. With the acquisition of eight holy relics, he will gain the power to overthrow the Almighty.</p>
<p class="tx">Six Templars stand above the rest in duty, honor, and loyalty. But each is haunted by a tragic past, and their darkened souls rapidly near the end. As they battle both the overwhelming power of evil and the nightmares of lives they left behind, the seraphs are more than tools to victory.</p>
<p class="tx">They are salvation.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// curse.vue?7caa7059